import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiRefreshCw,
  FiDownload,
  FiEdit,
  FiEye,
  FiEyeOff,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function MasterData() {
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [syncStatus, setSyncStatus] = useState("idle");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [schemes] = useState([
    {
      id: 1,
      schemeCode: "MF001",
      schemeName: "HDFC Equity Fund",
      amcName: "HDFC Mutual Fund",
      category: "Equity",
      isVisible: true,
      lastSynced: "2024-01-20 10:30 AM",
      nav: 125.50,
    },
    {
      id: 2,
      schemeCode: "MF002",
      schemeName: "ICICI Prudential Balanced Fund",
      amcName: "ICICI Prudential",
      category: "Hybrid",
      isVisible: true,
      lastSynced: "2024-01-20 10:30 AM",
      nav: 98.75,
    },
    {
      id: 3,
      schemeCode: "MF003",
      schemeName: "SBI Debt Fund",
      amcName: "SBI Mutual Fund",
      category: "Debt",
      isVisible: false,
      lastSynced: "2024-01-19 09:15 AM",
      nav: 45.20,
    },
  ]);

  const handleSync = () => {
    setSyncStatus("syncing");
    Swal.fire({
      title: "Syncing Master Data",
      text: "Please wait while we sync scheme master data...",
      icon: "info",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    setTimeout(() => {
      setSyncStatus("idle");
      Swal.fire("Success!", "Master data sync completed successfully.", "success");
    }, 2000);
  };

  const handleToggleVisibility = (schemeId) => {
    Swal.fire({
      title: "Change Visibility?",
      text: "Do you want to change the visibility of this scheme?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Change",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Updated!", "Scheme visibility has been updated.", "success");
      }
    });
  };

  const handleEditScheme = (schemeId) => {
    Swal.fire({
      title: "Edit Scheme",
      html: `
        <input id="schemeName" class="swal2-input" placeholder="Scheme Name" value="HDFC Equity Fund">
        <select id="category" class="swal2-select">
          <option value="Equity">Equity</option>
          <option value="Debt">Debt</option>
          <option value="Hybrid">Hybrid</option>
        </select>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Save Changes",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    });
  };

  const filteredSchemes = schemes.filter((scheme) => {
    const matchesSearch =
      scheme.schemeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      scheme.schemeCode.includes(searchTerm) ||
      scheme.amcName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = categoryFilter === "all" || scheme.category === categoryFilter;
    return matchesSearch && matchesCategory;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSchemes.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredSchemes.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                    <div className="content-page-header content-page-headersplit">
                <h5>MF Master Data (AMCs & Schemes)</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/mutual-funds/master-data">Mutual Funds</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Master Data
                  </li>
                </ol>
              </nav>
        
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
              {/* Filters */}
              <div className="row g-2 flex-grow-1">
                {/* Search */}
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by scheme name, code, or AMC..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>

                {/* Category Filter */}
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={categoryFilter}
                    onChange={(e) => {
                      setCategoryFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Categories</option>
                    <option value="Equity">Equity</option>
                    <option value="Debt">Debt</option>
                    <option value="Hybrid">Hybrid</option>
                  </select>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="ms-md-3 mt-3 mt-md-0">
                <button
                  className="btn btn-primary me-2"
                  onClick={handleSync}
                  disabled={syncStatus === "syncing"}
                >
                  {/* <FiRefreshCw className="me-2" /> */}
                  {syncStatus === "syncing" ? "Syncing..." : "Sync Master Data"}
                </button>
                <button className="btn btn-secondary">
                  {/* <FiDownload className="me-2" /> */}
                  Export
                </button>
              </div>
              </div>
            </div>

            {/* Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                    <thead>
                      <tr>
                        <th>Scheme Code</th>
                        <th>Scheme Name</th>
                        <th>AMC Name</th>
                        <th>Category</th>
                        <th>NAV</th>
                        <th>Visibility</th>
                        <th>Last Synced</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length === 0 ? (
                        <tr>
                          <td colSpan="8">No data available</td>
                        </tr>
                      ) : (
                        currentItems.map((scheme) => (
                          <tr key={scheme.id}>
                            <td style={{ fontWeight: "500" }}>{scheme.schemeCode}</td>
                            <td style={{ fontWeight: "500" }}>{scheme.schemeName}</td>
                            <td>{scheme.amcName}</td>
                            <td>
                              <span className="badge" style={{
                                background: "#f0f9ff",
                                color: "#006e82",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}>
                                {scheme.category}
                              </span>
                            </td>
                            <td style={{ fontWeight: "600" }}>₹{scheme.nav.toFixed(2)}</td>
                            <td>
                              <span className={scheme.isVisible ? "badge-active" : "badge-pending"}>
                                {scheme.isVisible ? "Visible" : "Hidden"}
                              </span>
                            </td>
                            <td>{scheme.lastSynced}</td>
                            <td>
                              <div className="table-actions d-flex justify-content-center">
                                <NavLink
                                  className="delete-table me-2"
                                  to={`/edit-mutualfund/${scheme.id}`}
                                  title="Edit Scheme"
                                >
                                  <i className="fas fa-edit"></i>
                                </NavLink>
                                <div
                                  className="delete-table"
                                  onClick={() => handleToggleVisibility(scheme.id)}
                                  title={scheme.isVisible ? "Hide Scheme" : "Show Scheme"}
                                  style={{ cursor: "pointer" }}
                                >
                                  {scheme.isVisible ? (
                                    <i className="fas fa-eye-slash"></i>
                                  ) : (
                                    <i className="fas fa-eye"></i>
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
